import { render, staticRenderFns } from "./RequisitionsItems.vue?vue&type=template&id=1ee71295&scoped=true"
import script from "./RequisitionsItems.vue?vue&type=script&lang=js"
export * from "./RequisitionsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee71295",
  null
  
)

export default component.exports